import { Button, Input, Modal, Select } from 'antd'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'

import Loader from '../../../pages/pages/loader'

import ServicesDropdown from '../../ServicesDropdown'
import { useAddCustomerServiceMutation, useUpdateCustomerServiceMutation } from '../../../redux/apis/customersManagement/services/cMcustomerServicesApiSlice'

const EditCreateServices = ({
  state,
  open,
  setOpen,
  record,
  customerId = null
}) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateCustomerServiceMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useAddCustomerServiceMutation()

  console.log(record)
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      service: record?.service?.id || '',
      service_frequency: record?.service_frequency?.toString() || '',
      customer: customerId || record?.customer,
    },

    validationSchema: Yup.object({
      service: Yup.number().required('Please Chosse Service'),
      service_frequency: Yup.number().required('Please Enter Service frequency')
    }),
    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Service created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Service updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={
        state === 'edit' ? `Edit ${record?.service?.service_name}` : 'Create Service'
      }
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      <div className=' mb-3'>
      <ServicesDropdown
        onChange={e => validation.setFieldValue('service', e)}
        onBlur={validation.handleBlur}
        value={validation.values.service}
        validation={validation}
        service_type="customer"
        service_category_name="collector"
      />
        {validation.touched.service &&
        validation.errors.service ? (
          <p className='text-danger'>{validation.errors.service}</p>
        ) : null}
      </div>

      <div className=' mb-3'>
        <label className="form-label">Service frequency (minutes)</label>
        <Input
          type='number'
          name='service_frequency'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.service_frequency}
        />
        {validation.touched.service_frequency &&
        validation.errors.service_frequency ? (
          <p className='text-danger'>{validation.errors.service_frequency}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateServices
